import React from 'react';
import DataTable from 'react-data-table-component';

export const tsrAdminTableStyles = {
  table: {
    style: {
      backgroundColor: '#fff'
    }
  },
  headRow: {
    style: {
      backgroundColor: '#f1f5f9',
      borderBottomWidth: '1px',
      borderBottomColor: '#e2e8f0',
      minHeight: '44px'
    }
  },
  headCells: {
    style: {
      fontSize: '0.875rem',
      fontWeight: 600,
      color: '#334155',
      paddingLeft: '12px',
      paddingRight: '12px'
    }
  },
  cells: {
    style: {
      fontSize: '0.875rem',
      color: '#1e293b',
      paddingLeft: '12px',
      paddingRight: '12px'
    }
  },
  rows: {
    style: {
      minHeight: '48px'
    },
    highlightOnHoverStyle: {
      backgroundColor: '#f8fafc',
      borderBottomColor: '#e2e8f0',
      outline: 'none'
    }
  },
  pagination: {
    style: {
      borderTop: '1px solid #e2e8f0',
      minHeight: '52px',
      fontSize: '0.875rem',
      color: '#475569'
    }
  }
};

function TsrAdminDataTable({
  columns,
  data,
  loading = false,
  paginationPerPage = 10,
  defaultSortFieldId,
  noDataComponent = 'No records found.'
}) {
  return (
    <div className="tsr-admin-datatable card border-0 shadow-sm">
      <div className="card-body p-0">
        <DataTable
          className="table-responsive"
          columns={columns}
          data={data}
          pagination
          paginationPerPage={paginationPerPage}
          persistTableHead
          progressPending={loading}
          customStyles={tsrAdminTableStyles}
          defaultSortFieldId={defaultSortFieldId}
          noDataComponent={<div className="p-4 text-muted text-center">{noDataComponent}</div>}
        />
      </div>
    </div>
  );
}

export default TsrAdminDataTable;
